
import { SearchBar } from "./search/SearchBar";
import { FilterOverlay } from "./search/FilterOverlay";
import { useSearchFilters } from "@/hooks/useSearchFilters";

export const SearchHeader = () => {
  const {
    showFilters,
    setShowFilters,
    distance,
    setDistance,
    rating,
    setRating,
    selectedFilters,
    recentSearches,
    cuisineTypes,
    dietaryTags,
    allergens,
    dateRange,
    setDateRange,
    availablePortions,
    setAvailablePortions,
    deliveryOnly,
    setDeliveryOnly,
    searchQuery,
    setSearchQuery,
    addToRecentSearches,
    toggleFilter,
    resetFilters,
    handleDatePreset,
  } = useSearchFilters();

  const handleSearch = () => {
    if (searchQuery) {
      addToRecentSearches(searchQuery);
    }

    setShowFilters(false);

    // Ensure we always have a valid distance value
    let distanceValue = 0;
    
    if (Array.isArray(distance) && distance.length > 0) {
      distanceValue = distance[0];
    } else if (typeof distance === 'number') {
      distanceValue = distance;
    }
    
    window.dispatchEvent(new CustomEvent('search', {
      detail: {
        filters: selectedFilters,
        distance: distanceValue,
        rating: Array.isArray(rating) ? rating[0] : rating,
        query: searchQuery,
        dateRange,
        availablePortions: Array.isArray(availablePortions) ? availablePortions[0] : availablePortions,
        deliveryOnly
      }
    }));
  };

  return (
    <>
      <div className="w-full">
        <SearchBar onSearchClick={() => setShowFilters(true)} />
      </div>

      {showFilters && (
        <div className="fixed inset-0 z-50">
          <FilterOverlay
            onClose={() => setShowFilters(false)}
            onReset={() => {
              resetFilters();
            }}
            onSearch={handleSearch}
            dateRange={dateRange}
            setDateRange={setDateRange}
            handleDatePreset={handleDatePreset}
            availablePortions={availablePortions}
            setAvailablePortions={setAvailablePortions}
            deliveryOnly={deliveryOnly}
            setDeliveryOnly={setDeliveryOnly}
            distance={Array.isArray(distance) && distance.length > 0 ? distance[0] : (typeof distance === 'number' ? distance : 0)}
            setDistance={setDistance}
            rating={rating}
            setRating={setRating}
            recentSearches={recentSearches}
            cuisineTypes={cuisineTypes}
            dietaryTags={dietaryTags}
            allergens={allergens}
            selectedFilters={selectedFilters}
            onToggleFilter={toggleFilter}
            searchQuery={searchQuery}
            onSearchQueryChange={setSearchQuery}
          />
        </div>
      )}
    </>
  );
};
